import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { SocketProvider } from './context/SocketContext';
import { CallProvider } from './context/CallContext';
import { LanguageProvider } from './i18n';
import Navbar from './components/Navbar';
import LoginPage from './pages/LoginPage';
import LandingPage from './pages/LandingPage';
import JapaneseLandingPage from './pages/JapaneseLandingPage';
import RegisterPage from './pages/RegisterPage';
import DiscoveryPage from './pages/DiscoveryPage';
import ProfilePage from './pages/ProfilePage';
import PricingPage from './pages/PricingPage';
import MarketplacePage from './pages/MarketplacePage';
import CartPage from './pages/CartPage';
import OrdersPage from './pages/OrdersPage';
import ShopPage from './pages/ShopPage';
import ShopFrontPage from './pages/ShopFrontPage';
import MomentsPage from './pages/MomentsPage';
import DownloadPage from './pages/DownloadPage';
import CommunityPage from './pages/CommunityPage';
import FriendsPage from './pages/FriendsPage';
import LikesPage from './pages/LikesPage';
import AdminReviewsPage from './pages/AdminReviewsPage';
import AdminPage from './pages/AdminPage';
import './App.css';

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <LoadingScreen />;
  return user ? children : <Navigate to="/login" />;
}

function LoadingScreen() {
  return (
    <div className="page-center">
      <div className="splash">
        <div className="splash-icon">🌍</div>
        <div className="splash-text">Global Heart</div>
        <div className="splash-loader" />
      </div>
    </div>
  );
}

function AnalyticsTracker() {
  const location = useLocation();
  useEffect(() => {
    try {
      const key = 'gh_visitor_id';
      let visitorId = localStorage.getItem(key);
      if (!visitorId) {
        visitorId = (typeof crypto !== 'undefined' && crypto.randomUUID) ? crypto.randomUUID() : (Date.now().toString(36) + Math.random().toString(36).slice(2));
        localStorage.setItem(key, visitorId);
      }
      fetch('/api/analytics/pageview', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ path: location.pathname, visitorId }) }).catch(() => {});
    } catch (_) {}
  }, [location.pathname]);
  return null;
}
function AppRoutes() {
  const { user, loading } = useAuth();
  if (loading) return <LoadingScreen />;
  return (
    <BrowserRouter><AnalyticsTracker /><Navbar />
      <Routes>
        <Route path="/welcome/ja" element={<JapaneseLandingPage />} />
        <Route path="/welcome" element={<LandingPage />} />
        <Route path="/login" element={user ? <Navigate to="/discover" /> : <LoginPage />} />
        <Route path="/register" element={user ? <Navigate to="/discover" /> : <RegisterPage />} />
        <Route path="/discover" element={<ProtectedRoute><DiscoveryPage /></ProtectedRoute>} />
        <Route path="/profile/:userId" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
        <Route path="/pricing" element={<ProtectedRoute><PricingPage /></ProtectedRoute>} />
        <Route path="/marketplace" element={<ProtectedRoute><MarketplacePage /></ProtectedRoute>} />
        <Route path="/moments" element={<ProtectedRoute><MomentsPage /></ProtectedRoute>} />
        <Route path="/download" element={<DownloadPage />} />
        <Route path="/community" element={<ProtectedRoute><CommunityPage /></ProtectedRoute>} />
        <Route path="/friends" element={<ProtectedRoute><FriendsPage /></ProtectedRoute>} />
        <Route path="/likes" element={<ProtectedRoute><LikesPage /></ProtectedRoute>} />
        <Route path="/admin" element={<ProtectedRoute><AdminPage /></ProtectedRoute>} />
        <Route path="/marketplace/cart" element={<ProtectedRoute><CartPage /></ProtectedRoute>} />
        <Route path="/marketplace/orders" element={<ProtectedRoute><OrdersPage /></ProtectedRoute>} />
        <Route path="/shop" element={<ProtectedRoute><ShopPage /></ProtectedRoute>} />
        <Route path="/shop/:shopId" element={<ProtectedRoute><ShopFrontPage /></ProtectedRoute>} />
        <Route path="/admin/reviews" element={<ProtectedRoute><AdminReviewsPage /></ProtectedRoute>} />
        <Route path="/" element={user ? <Navigate to="/discover" /> : <Navigate to="/welcome" />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <SocketProvider>
          <CallProvider>
            <AppRoutes />
          </CallProvider>
        </SocketProvider>
      </AuthProvider>
    </LanguageProvider>
  );
}
